<template>
  <div>
    <CostMasterModal
      v-if="!loading && masterModal"
      ref="master-modal"
      :cost-id="parseInt(costId)"
      :stage="masterModal"
      :emit-only="isControlPanel"
      @close="closeCostsModal"
      @cost-edited="onCostEdited"
    />

    <TitleBar>
      <template v-slot:title><translate>Costs</translate></template>
      <template v-slot:buttons>
        <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_costs'" /> -->

        <GekkoButton 
          v-if="!isControlPanel"
          :text="$gettext('New Cost')" 
          icon="fa-solid fa-plus"
          :to="Urls['costs_add_cost']()"
          class="btn mr-2"
        />

        <GekkoButton 
          v-if="isControlPanel"
          :text="$gettext('New Cost')" 
          icon="fa-solid fa-plus"
          :to="Urls['accountants:add_costs'](visitingCompanyId)"
          class="btn mr-2"
        />

        <b-dropdown right variant="outline-primary">
          <template #button-content>
            <font-awesome-icon icon="fa-solid fa-cloud-download" /><span v-translate>Download</span>
          </template>
          <b-dropdown-item @click="exportCosts('csv')" v-b-tooltip.hover.right :title="tooltipTextXls">
            <font-awesome-icon icon="fa-regular fa-file" /><span v-translate>as excel file (.xls)</span>
          </b-dropdown-item>
          <b-dropdown-item @click="exportCosts('zip')" class="act" v-b-tooltip.hover.right :title="tooltipTextZip">
            <font-awesome-icon icon="fa-regular fa-file-zipper" /><span v-translate>xls + images (.zip)</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </TitleBar>
    <div class="content">
      <CostTable v-if="!isControlPanel" :excludeTableFields="['is_invoiced']" />
      <AccountantCostTable ref="editable_cost_table" v-if="isControlPanel" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"

import { promptDownload } from "@/utils/"

import TitleBar from "@/components/TitleBar"
import CostTable from "@/components/costs/CostTable"
import GekkoButton from "@/components/GekkoButton"
import AccountantCostTable from "@/components/accountants/control_panel/AccountantCostTable"
import CostService from "@/store/services/cost.service.js"
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

import CostMasterModal from "@/components/costs/CostMasterModal"

export default {
  name: "Costs",
  components: {
    TitleBar,
    CostTable,
    GekkoButton,
    AccountantCostTable,
    // OnboardingIntroLink,
    CostMasterModal
  },
  data () {
    return {
      tooltipTextZip: this.$gettext("Download current selection as xls, and include the proof images, as ZIP archive."),
      tooltipTextXls: this.$gettext("Download current selection as xls only."),
      loading: true,
      masterModal: null,
      costId: null,
    }
  },
  computed:{
    ...mapGetters ({
      visitingCompanyId: 'main/getVisitingCompanyId'
    }),
    isControlPanel () {
      return this.$route.path.includes('control-panel')
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        if (!this.isControlPanel) {
          this.masterModal = to.meta.masterModal
        } else {
          if (this.$route.name === 'ControlPanelEditCost') this.masterModal = 'edit'
          else if (this.$route.name === 'ControlPanelAddCost') this.masterModal = 'add'
          else {
            this.masterModal = null
          }
        }
        this.costId = this.$route.params['costId']
        if (this.masterModal) {
          document.body.classList.add('master-modal-on')
        } else {
          document.body.classList.remove('master-modal-on')
        }
      }
    },
  },
  created () {
    this.loadCostsGlobalData().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions ({
      loadCostsGlobalData: 'costs/loadCostsGlobalData'
    }),
    exportCosts (exportFormat) {
      if (this.isDownloadButtonDisabled()) {
        this.$store.commit('setAlert', {
          title: this.$gettext("Cost Download"),
          text: this.$gettext("For security reasons, you cannot initiate another download for 2 minutes."),
          variant:"info",duration:4});
        return;
      }
      var url;

      if (this.isControlPanel) {
        if (exportFormat === 'csv') {
          url = window.Urls['v3:cost_export_costs'](this.visitingCompanyId);
        }
      } else {
        if (exportFormat === 'csv') {
          url = window.Urls['v3:cost_export_costs']();
        }
      }

      let filters = this.$store.getters['filterStore/getFilter'];
      if (this.isControlPanel) {
        filters.control_panel = true;
      }
      filters.owner_company = this.visitingCompanyId;
      delete filters.option;

    if (exportFormat === "zip") {
        CostService.downloadCostsZip(filters).then(()=>{
          var alert_text = this.$gettext("You will receive an email with your download URL as soon as your export is ready.");
          this.$store.commit('setAlert', {title: this.$gettext("Cost Download"), text:alert_text, variant:"info",duration:4});
        })
      }else{
        CostService.exportCSV(url, filters).then(response => {
          promptDownload(response)
        }).catch(error => console.error('Error downloading file:', error));
      }
    
      var expiry_date = new Date();
      expiry_date.setSeconds(expiry_date.getSeconds() + 2*60);
      this.$cookies.set("disable_download_csv_button", true, expiry_date);

    },
    isDownloadButtonDisabled () {
      return this.$cookies.get("disable_download_csv_button") === "true";
    },
    closeCostsModal () {
      this.masterModal = null
      if (this.isControlPanel) {
        this.$router.push({ name: 'ControlPanelCosts' }).catch(() => {})
      } else {
        this.$router.push({ name: 'Costs' }).catch(() => {})
      }
    },
    onCostEdited () {
      // TODO this is a bad solution for control-panel, should have it's own view file (~ControlPanelCosts)
      if (this.isControlPanel) {
        this.$store.commit('costs/REFRESH_COST_LIST')
        this.$router.push({ name: 'ControlPanelCosts' }).catch(() => {})
      }
    }
  }
}
</script>
<style scoped>

</style>
